document.addEventListener('DOMContentLoaded', function () {
  // ---------------- FAQ accordion ----------------
  document.querySelectorAll('.faq-q').forEach(function (q) {
    var a = q.nextElementSibling;
    if (!a) return;
    a.style.display = 'none';
    q.addEventListener('click', function () {
      var open = a.style.display === 'block';
      a.style.display = open ? 'none' : 'block';
      q.setAttribute('aria-expanded', String(!open));
      q.classList.toggle('open', !open);
    });
  });

  // ---------------- Mobile menu ----------------
  var menu = document.querySelector('[data-az-menu]');
  var burger = document.querySelector('[data-az-menu-open]');
  if (menu && burger) {
    burger.addEventListener('click', function () {
      var open = !menu.hidden;
      menu.hidden = open;
      burger.setAttribute('aria-expanded', String(!open));
      burger.classList.toggle('open', !open);
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        menu.hidden = true;
        burger.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ---------------- Autoplay videos on scroll ----------------
  var videos = document.querySelectorAll('[data-az-video]');
  if (videos.length) {
    if ('IntersectionObserver' in window) {
      var vObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.4 });
      videos.forEach(function (v) { vObserver.observe(v); });
    } else {
      videos.forEach(function (v) { v.setAttribute('autoplay', ''); });
    }

    document.querySelectorAll('[data-az-video-sound]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.video-card');
        var v = card.querySelector('video');
        var turningOn = v.muted;
        videos.forEach(function (other) {
          other.muted = true;
          var b = other.parentElement.querySelector('[data-az-video-sound]');
          if (b) b.textContent = '🔇';
        });
        if (turningOn) {
          v.muted = false;
          btn.textContent = '🔊';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    });
  }

  // ---------------- Variant picker ----------------
  var variantInputs = document.querySelectorAll('input[name="az-variant"]');
  var bundleInputs = document.querySelectorAll('input[name="az-bundle"]');
  var priceEls = document.querySelectorAll('[data-az-price]');
  var totalEls = document.querySelectorAll('[data-az-total]');
  var comparePriceEls = document.querySelectorAll('[data-az-compare]');
  var stickyImg = document.querySelector('[data-az-sticky-img]');
  var stickyName = document.querySelector('[data-az-sticky-name]');
  var formIdInputs = document.querySelectorAll('[data-az-variant-id-field]');
  var qtyInput = document.querySelector('[data-az-qty]');

  function selectVariant(input) {
    variantInputs.forEach(function (i) {
      var c = i.closest('.color-card') || i.closest('.variant-swatch-card');
      if (c) c.classList.remove('selected');
    });
    var card = input.closest('.color-card') || input.closest('.variant-swatch-card');
    if (card) card.classList.add('selected');

    var price = input.getAttribute('data-price');
    var compare = input.getAttribute('data-compare');
    var img = input.getAttribute('data-image');
    var name = input.getAttribute('data-name');

    priceEls.forEach(function (el) { el.textContent = price; });
    comparePriceEls.forEach(function (el) {
      if (compare && compare !== price) { el.textContent = compare; el.style.display = 'inline'; }
      else { el.style.display = 'none'; }
    });
    if (stickyImg && img) stickyImg.setAttribute('src', img);
    if (stickyName && name) stickyName.textContent = name;
    formIdInputs.forEach(function (el) { el.value = input.value; });
  }

  variantInputs.forEach(function (input) {
    input.addEventListener('change', function () { selectVariant(input); });
  });
  var checked = document.querySelector('input[name="az-variant"]:checked');
  if (checked) selectVariant(checked);

  // ---------------- Bundle tiers ----------------
  function selectBundle(input) {
    bundleInputs.forEach(function (i) {
      var c = i.closest('[data-bundle-card]');
      if (c) c.classList.remove('selected');
    });
    var card = input.closest('[data-bundle-card]');
    if (card) card.classList.add('selected');
    if (qtyInput) qtyInput.value = input.getAttribute('data-qty') || '1';
    var total = input.getAttribute('data-total');
    if (total) totalEls.forEach(function (el) { el.textContent = total; });
  }
  bundleInputs.forEach(function (input) {
    input.addEventListener('change', function () { selectBundle(input); });
  });
  var checkedBundle = document.querySelector('input[name="az-bundle"]:checked');
  if (checkedBundle) selectBundle(checkedBundle);

  // ---------------- Quantity stepper ----------------
  function syncBundleFromQty() {
    if (!qtyInput) return;
    var q = parseInt(qtyInput.value || '1', 10);
    var match = document.querySelector('input[name="az-bundle"][data-qty="' + q + '"]');
    bundleInputs.forEach(function (i) {
      var c = i.closest('[data-bundle-card]');
      if (c) c.classList.remove('selected');
      i.checked = false;
    });
    if (match) { match.checked = true; selectBundle(match); }
  }
  document.querySelectorAll('[data-az-qty-decrease]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (qtyInput) qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      syncBundleFromQty();
    });
  });
  document.querySelectorAll('[data-az-qty-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (qtyInput) qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
      syncBundleFromQty();
    });
  });
  if (qtyInput) qtyInput.addEventListener('change', syncBundleFromQty);

  // ---------------- Cart drawer ----------------
  var drawer = document.querySelector('[data-az-cart-drawer]');
  var overlay = document.querySelector('[data-az-cart-overlay]');
  var itemsEl = document.querySelector('[data-az-cart-items]');
  var emptyEl = document.querySelector('[data-az-cart-empty]');
  var footEl = document.querySelector('[data-az-cart-foot]');
  var subtotalEl = document.querySelector('[data-az-cart-subtotal]');
  var drawerCountEl = document.querySelector('[data-az-drawer-count]');
  var navCountEl = document.querySelector('[data-az-cart-count]');
  var promoEl = document.querySelector('[data-az-cart-promo]');

  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      try { return window.Shopify.formatMoney(cents); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    if (!drawer) return;
    overlay.hidden = false;
    requestAnimationFrame(function () {
      overlay.classList.add('open');
      drawer.classList.add('open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
  }

  function closeDrawer() {
    if (!drawer) return;
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
    setTimeout(function () { overlay.hidden = true; }, 300);
  }

  function renderCart(cart) {
    var count = cart.item_count || 0;

    if (navCountEl) {
      navCountEl.textContent = count;
      navCountEl.hidden = count === 0;
    }
    if (drawerCountEl) drawerCountEl.textContent = count > 0 ? count + (count === 1 ? ' item' : ' items') : '';

    var shipEl = document.querySelector('[data-az-ship-note]');
    if (shipEl) {
      if (count === 0) {
        shipEl.hidden = true;
      } else if (count === 1) {
        shipEl.hidden = false;
        shipEl.className = 'cart-drawer-ship';
        shipEl.innerHTML = '🚚 Add <strong>1 more</strong> and shipping is <strong>free</strong>.';
      } else {
        shipEl.hidden = false;
        shipEl.className = 'cart-drawer-ship won';
        shipEl.innerHTML = '✅ Free shipping unlocked.';
      }
    }

    if (promoEl) {
      if (count === 0) {
        promoEl.hidden = true;
      } else if (count === 1) {
        promoEl.hidden = false;
        promoEl.className = 'cart-drawer-promo';
        promoEl.innerHTML = '🎁 Add <strong>3 more</strong> and your 4th AirZooka is <strong>FREE</strong>.';
      } else if (count === 2) {
        promoEl.hidden = false;
        promoEl.className = 'cart-drawer-promo';
        promoEl.innerHTML = '🎁 Add <strong>2 more</strong> and your 4th AirZooka is <strong>FREE</strong>.';
      } else if (count === 3) {
        promoEl.hidden = false;
        promoEl.className = 'cart-drawer-promo close';
        promoEl.innerHTML = '🔥 So close — add <strong>1 more</strong> and it is <strong>FREE</strong>.';
      } else {
        promoEl.hidden = false;
        promoEl.className = 'cart-drawer-promo won';
        promoEl.innerHTML = '✅ Buy 3 Get 1 Free unlocked — discount applies at checkout.';
      }
    }

    if (!itemsEl) return;

    if (count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'block';
      if (footEl) footEl.hidden = true;
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footEl) footEl.hidden = false;
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    itemsEl.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_160x160$1$2') : '';
      var variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      return '' +
        '<div class="cart-line" data-line="' + (i + 1) + '">' +
          (img ? '<img src="' + img + '" alt="">' : '') +
          '<div class="cart-line-info">' +
            '<div class="cart-line-title">' + item.product_title + '</div>' +
            (variantLabel ? '<div class="cart-line-variant">' + variantLabel + '</div>' : '') +
            '<div class="cart-line-price">' + money(item.final_line_price) + '</div>' +
            '<div class="cart-line-controls">' +
              '<div class="cart-qty-box">' +
                '<button type="button" data-az-line-minus aria-label="Decrease quantity">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-az-line-plus aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="cart-line-remove" data-az-line-remove>Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  if (itemsEl) {
    itemsEl.addEventListener('click', function (e) {
      var lineEl = e.target.closest('[data-line]');
      if (!lineEl) return;
      var line = parseInt(lineEl.getAttribute('data-line'), 10);
      var current = parseInt(lineEl.querySelector('.cart-qty-box span').textContent, 10);
      if (e.target.hasAttribute('data-az-line-plus')) changeLine(line, current + 1);
      else if (e.target.hasAttribute('data-az-line-minus')) changeLine(line, Math.max(0, current - 1));
      else if (e.target.hasAttribute('data-az-line-remove')) changeLine(line, 0);
    });
  }

  document.querySelectorAll('[data-az-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  document.querySelectorAll('[data-az-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); openDrawer(); });
    });
  });

  // ---------------- Add to cart -> open drawer ----------------
  document.querySelectorAll('[data-az-atc-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"][name="add"]') || form.querySelector('button[type="submit"]');
      var originalText = btn ? btn.innerHTML : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      var fd = new FormData(form);
      fd.delete('az-variant');
      fd.delete('az-bundle');

      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          openDrawer();
          if (btn) { btn.innerHTML = originalText; btn.disabled = false; }
        })
        .catch(function () {
          if (btn) { btn.innerHTML = originalText; btn.disabled = false; }
          window.location.href = '/cart';
        });
    });
  });

  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(renderCart)
    .catch(function () {});
});
